import { decode } from "html-entities";
const MAX_DECODE_PASSES = 5;
/**
 * Decode HTML entities for link card display (title / description / summary).
 * Repeats until stable so double-encoded CMS text (e.g. `&amp;#039;`) becomes plain Unicode.
 */
export function decodeHtmlEntitiesForDisplay(raw) {
    if (raw === "") {
        return "";
    }
    let prev = raw;
    for (let i = 0; i < MAX_DECODE_PASSES; i++) {
        const next = decode(prev);
        if (next === prev) {
            return next;
        }
        prev = next;
    }
    return prev;
}
